/* eslint-disable import/prefer-default-export */

export const startSurfly = () => {
  window.Surfly.session()
    .on('session_started', () => {})
    .startLeader();
};
